"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'authTemplates.login.title',
        defaultMessage: 'Log in',
        description: 'Login title',
    },
    description: {
        id: 'authTemplates.login.description',
        defaultMessage: 'Please enter your details.',
        description: 'Login description',
    },
    emailPlaceholder: {
        id: 'authTemplates.login.email.placeholder',
        defaultMessage: 'Enter your email',
        description: 'Login email placeholder',
    },
    registerPart1: {
        id: 'authTemplates.login.register.1',
        defaultMessage: 'Register using',
        description: 'Login register link part 1',
    },
    registerPart2: {
        id: 'authTemplates.login.register.2',
        defaultMessage: 'Activation code',
        description: 'Login register link part 2',
    },
    openRegisterPart1: {
        id: 'authTemplates.login.register.open.1',
        defaultMessage: 'No user account yet? Please ',
    },
    openRegisterPart2: {
        id: 'authTemplates.login.register.open.2',
        defaultMessage: 'Sign up',
    },
    successfullRegistration: {
        id: 'authTemplates.login.registeration.success',
        defaultMessage: 'You have successfully registered as a user with an AGCO account. Please enter your details.',
    },
    inactivityLogout: {
        id: 'authTemplates.login.inactivityLogout',
        defaultMessage: 'Your session has expired due to inactivity. Please log in again.',
    },
});
exports.default = messages;
